import {
  RENTAL_PORTAL_FACT_SEPARATOR,
  RENTAL_PORTAL_LISTING_STATUS,
} from '../../../../../constants/rentalPortal'
import { formatNumberWithSeparators } from '../../../../../utils/number'
import { getListingRentDisplayValue } from '../../../../RentalPortalListing'

function joinListingBoardCardMeta(parts) {
  return parts.filter(Boolean).join(RENTAL_PORTAL_FACT_SEPARATOR)
}

function getListingBoardCardBaseMeta({ item, t }) {
  return [
    getListingRentDisplayValue(item),
    item.flat?.area
      ? `${formatNumberWithSeparators(item.flat.area)} ${t('Common.AreaUnitKey')}`
      : null,
  ]
}

function getListingBoardCardOpenChecks({ publishReadiness, t }) {
  const openCount =
    publishReadiness?.filter(check => !check.is_done).length ?? 0

  return openCount > 0
    ? t('RentalPortal.ListingBoardOpenStepsKey', { count: openCount })
    : null
}

// TODO: the list payload carries neither the inquiry count the published card
// owes, nor the approved applicant and let date the closed one owes, nor the
// off-market date for deactivated — those three cards fall back to rent and area
// until the listings endpoint serves the fields.
export function getListingBoardCardMeta({ item, t }) {
  switch (item.status) {
    case RENTAL_PORTAL_LISTING_STATUS.draft:
      return joinListingBoardCardMeta([
        ...getListingBoardCardBaseMeta({ item, t }),
        getListingBoardCardOpenChecks({
          publishReadiness: item.publish_readiness,
          t,
        }),
      ])
    case RENTAL_PORTAL_LISTING_STATUS.published:
      return t('RentalPortal.ListingBoardPortalCountKey', {
        count: item.portal_status_summary?.length ?? 0,
      })
    default:
      return joinListingBoardCardMeta(getListingBoardCardBaseMeta({ item, t }))
  }
}
